import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import Zoomist from 'zoomist';
export var interactiveImageBehavior = function interactiveImageBehavior() {
  Alpine.data('interactiveImageBehavior', function () {
    return {
      $zoom: false,
      expandReady: false,
      imgIsExpanded: false,
      init: function init() {
        var _this = this;
        this.pattern_classname = 'm-interactive-image';
        this.expandableWrapper = this.$el.querySelector(".".concat(this.pattern_classname, "__expanded-wrapper"));
        this.expandableContainer = this.$el.querySelector('[data-zoomist]');
        this.zoomInButton = this.expandableWrapper.querySelector(".".concat(this.pattern_classname, "__zoom-in"));
        this.zoomOutButton = this.expandableWrapper.querySelector(".".concat(this.pattern_classname, "__zoom-out"));
        this.closeExpandButton = this.expandableWrapper.querySelector('[x-bind="bindClose"]');
        this.expandableImg = this.expandableContainer.querySelector('img');
        this.$watch('imgIsExpanded', function (isOpen) {
          if (isOpen) {
            document.body.classList.add('overflow-hidden');
            if (_this.$zoom) {
              setTimeout(function () {
                return _this.$zoom.update();
              }, 100);
            }
          } else {
            document.body.classList.remove('overflow-hidden');
          }
        });
      },
      initExpandableImage: function initExpandableImage() {
        var _this2 = this;
        this.$zoom = new Zoomist(this.expandableContainer, {
          src: this.expandableImg,
          height: false,
          slider: true,
          fill: 'cover',
          bounds: true,
          zoomRatio: 0.1,
          maxRatio: 5,
          wheelable: true,
          pinchable: true,
          zoomer: {
            inEl: this.zoomInButton,
            outEl: this.zoomOutButton
          }
        });
        if (this.$zoom) {
          this.$zoom.on('ready', function () {
            _this2.expandReady = true;
          });
        }
      },
      bindInteractiveImage: {
        '@resize.window.stop.debounce': function resizeWindowStopDebounce() {
          if (this.$zoom) {
            this.$zoom.update();
          }
        },
        '@keydown.esc.window': function keydownEscWindow() {
          this.imgIsExpanded = false;
        }
      },
      bindExpand: {
        '@click': function click() {
          if (!this.expandReady) {
            this.initExpandableImage();
          }
          if (this.$zoom) {
            this.imgIsExpanded = true;
          }
        }
      },
      bindClose: {
        '@click': function click() {
          this.imgIsExpanded = false;
        }
      }
    };
  });
};